function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "asterisk_svg__icon-stroke",
  fill: "none",
  strokeWidth: 2,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1 12.46h22M6.5 21.92L17.5 3m0 18.92L6.5 3"
});

function SvgAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggY2xhc3M9Imljb24tc3Ryb2tlIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xLDEyLjQ2IEwyMywxMi40NiBNNi41LDIxLjkyIEwxNy41LDMgTTE3LjUsMjEuOTIgTDYuNSwzIi8+Cjwvc3ZnPgo=";
export { SvgAsterisk as ReactComponent };